import React, { Component } from 'react'
import '../styles/AllThemesCalendar.css'
import LAIconSmall from '../images/Themes/icon-small-la.png'
import VBNIconSmall from '../images/Themes/icon-small-vbn.png'
import AbattoirIconSmall from '../images/Themes/icon-small-abattoir.png'
import YakuzaIconSmall from '../images/Themes/icon-small-yakuza.png'
import TombeauIconSmall from '../images/Themes/icon-small-tombeau.png'
import { injectIntl, defineMessages } from "react-intl"
import moment from 'moment'
import 'moment/locale/fr'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import faCalendarTimes from '@fortawesome/fontawesome-free-solid/faCalendarTimes'
import utils from '../utils.json'

const weekLimit = utils.weekLimit

const themeCodeBuilder = (code) => {
  switch (`${code}`) {
    case '1':
    case '27':
      return 'la'
    case '2':
    case '28':
      return 'vbn'
    case '5':
    case '29':
      return 'abattoir'
    case '6':
    case '31':
      return 'yakuza'
    case '4':
    case '32':
      return 'tombeau'
    default:
      break
  }
}

const getThemeFromRoomName = (name) => {
  const normalizedName = `${name || ''}`
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

  if (normalizedName.indexOf('lost') > -1) return 'la'
  if (normalizedName.indexOf('very bad') > -1 || normalizedName.indexOf('vbn') > -1) return 'vbn'
  if (normalizedName.indexOf('abattoir') > -1) return 'abattoir'
  if (normalizedName.indexOf('yakuza') > -1) return 'yakuza'
  if (normalizedName.indexOf('expedition') > -1 || normalizedName.indexOf('maudite') > -1 || normalizedName.indexOf('tombeau') > -1) return 'tombeau'
}

const getSlotRoomId = (slot) => {
  if (!slot) return ''

  const roomId = slot.room_id
    || slot.id_room
    || slot.id_room_escape
    || slot.id_room_enigma
    || slot.roomId
    || slot.idRoom
    || slot.room_id_escape
    || ''

  if (roomId) return roomId

  return /^\d+$/.test(`${slot.room || ''}`) ? slot.room : ''
}

const getSlotTheme = (slot) => {
  if (!slot) return ''

  const rawTheme = `${slot.room || slot.theme || ''}`.toLowerCase()
  if (['la', 'vbn', 'abattoir', 'yakuza', 'tombeau'].indexOf(rawTheme) > -1) {
    return rawTheme
  }

  return themeCodeBuilder(getSlotRoomId(slot))
    || getThemeFromRoomName(`${slot.room_name || ''} ${slot.roomname || ''} ${slot.name || ''} ${slot.name_enigma || ''} ${slot.enigma_name || ''}`)
}

const stripTimeBegin = (time) => {
  if (time) {
    return time.split(":")[0]
  }
}

const stripMinutes = (time) => {
  return parseInt(time.split(':')[1]) > -1 ? time.split(':')[1] : '';
}

const formatDateToEnglish = (date) => {
  const arr = date.split('/')

  return `${arr[1]}-${arr[0]}-${arr[2]}`
}

const isOverMonthLimit = slotDate => slotDate < moment().add(weekLimit, 'w').subtract(1, 'd')

const getDiscountAmount = (slot) => {
  const amount = parseFloat(slot && slot.last_minute_discount_amount ? slot.last_minute_discount_amount : 0)
  return Number.isFinite(amount) && amount > 0 ? amount : 0
}

const formatDiscountAmount = (amount) => {
  return Math.abs(amount - Math.round(amount)) < 0.01 ? Math.round(amount) : amount.toFixed(2).replace('.', ',')
}

class AllThemesCalendar extends Component {

  handleClick = (data) => {
    const cell = data.target.closest ? data.target.closest('td') : data.target
    if (cell && !cell.className.includes("selected")) {
      this.props.handleClick(cell.id)
    }
  }

  getRoomSlots = (idRoom) => {
    const expectedTheme = themeCodeBuilder(idRoom)
    const mappedRoomId = expectedTheme && this.props.roomIdsByTheme
      ? this.props.roomIdsByTheme[expectedTheme]
      : null
    const slots = Array.isArray(this.props.slots) ? this.props.slots : []
    const roomSlots = slots.filter(x => x && (
      `${x.id_room}` === `${idRoom}`
      || `${x.room_id}` === `${idRoom}`
      || (mappedRoomId && `${x.id_room}` === `${mappedRoomId}`)
      || (mappedRoomId && `${x.room_id}` === `${mappedRoomId}`)
      || (expectedTheme && themeCodeBuilder(getSlotRoomId(x)) === expectedTheme)
      || (expectedTheme && getThemeFromRoomName(`${x.room_name || ''} ${x.roomname || ''} ${x.name || ''} ${x.name_enigma || ''} ${x.enigma_name || ''}`) === expectedTheme)
    )).shift()

    if (roomSlots && roomSlots.calendar && roomSlots.calendar.length > 0) {
      return roomSlots.calendar
    }

    const fallbackIndexes = {
      "1": 0,
      "27": 0,
      "2": 1,
      "28": 1,
      "5": 2,
      "29": 2,
      "6": 3,
      "31": 3,
      "4": 4,
      "32": 4
    }
    const fallbackSlot = slots[fallbackIndexes[`${idRoom}`]]

    if (fallbackSlot && fallbackSlot.calendar && fallbackSlot.calendar.length > 0) {
      return fallbackSlot.calendar
    }

    return emptyCalendar
  }

  getRoomIdForTheme = (theme, fallbackRoomId) => {
    return this.props.roomIdsByTheme && this.props.roomIdsByTheme[theme]
      ? this.props.roomIdsByTheme[theme]
      : fallbackRoomId
  }

  stripHours = (time) => {
    return time.split(':').shift()
  }

  buildSlotCode = (booking, withMinutes) => {
    const theme = getSlotTheme(booking)
    const roomId = this.getCalendarRoomId(booking)
    if (withMinutes)
      return `${theme}|${booking.reservation_date}|${stripTimeBegin(booking.time_begin)}||${stripMinutes(booking.time_begin)}|${roomId}`
    else
      return `${theme}|${booking.reservation_date}|${stripTimeBegin(booking.time_begin)}`
  }

  isSlotSelected = (cellId) => {
    return this.props.selectedSlots.some(booking => {
      return cellId.indexOf(this.buildSlotCode(booking, false)) === 0
    })
  }

  getCalendarRoomId = (slot, fallbackRoomId) => {
    const expectedTheme = themeCodeBuilder(fallbackRoomId)
    const mappedRoomId = expectedTheme && this.props.roomIdsByTheme
      ? this.props.roomIdsByTheme[expectedTheme]
      : null

    return getSlotRoomId(slot) || mappedRoomId || fallbackRoomId
  }

  formatDate = (date) => {
    const formattedDate = date.format('l').split("/")
    let y, M, d

    y = formattedDate[2]
    M = formattedDate[1].length < 2 ? `0${formattedDate[1]}` : formattedDate[1]
    d = formattedDate[0].length < 2 ? `0${formattedDate[0]}` : formattedDate[0]

    if (this.props.lang === "fr") {
      return `${y}-${M}-${d}`
    } else {
      return `${y}-${d}-${M}`
    }
  }

  checkAvailability = (slot) => {
    const minutesBefore = Number.isFinite(Number(slot.minutes_before_reservation)) ? Number(slot.minutes_before_reservation) : 60
    const inOneHour = moment().add(minutesBefore, 'minute')
    const date = this.props.lang === "fr" ? this.props.date.format('L') : formatDateToEnglish(this.props.date.format('L'))
    const hour = slot.time_begin
    const slotDate = moment(date + ' ' + hour, 'DD/MM/YYYY HH:mm:ss')
    return inOneHour < slotDate && isOverMonthLimit(slotDate)
  }

  updateCells = () => {

    document.querySelectorAll("td").forEach(td => {
      td.classList.remove("theme-calendar--selected")
    })

    if (this.props.selectedSlots.length > 0) {
      this.props.selectedSlots.forEach(booking => {
        let formattedSlot = this.buildSlotCode(booking, false)
        const selectedCell = document.querySelectorAll(`[id^='${formattedSlot}']`)
        formattedSlot = this.buildSlotCode(booking, true)
        if (selectedCell.length > 0) {
          const themeCode = getSlotTheme(booking) || themeCodeBuilder(getSlotRoomId(booking))
          selectedCell[0].classList.add("theme-calendar-cell-all", "theme-calendar--selected", `theme-calendar-cell-all--${themeCode}`)
          selectedCell[0].onclick = (data) => this.handleClick(data)
          selectedCell[0].classList.remove("theme-calendar-unavailable")
        }
      })
    }
  }

  componentDidMount() {
    this.updateCells()
  }

  componentDidUpdate() {
    this.updateCells()
  }

  renderRoomCells = (theme, roomId) => {
    const roomSlots = this.getRoomSlots(roomId)

    return Object.keys(roomSlots).map((x, i) => {
      const slot = roomSlots[x]
      const slotHour = this.stripHours(slot.time_begin)
      const slotMinutes = stripMinutes(slot.time_begin)
      const discountAmount = getDiscountAmount(slot)
      const priceType = slot.global_price || slot.normal_price_type || 'c'
      const cellId = `${theme}|${this.formatDate(this.props.date)}|${slotHour}|${this.stripHours(slot.id_room_calendar)}|${slotMinutes}|${this.getCalendarRoomId(slot, roomId)}|${discountAmount}|${priceType}`
      const isSelected = this.isSlotSelected(cellId)
      const canRenderSlot = isSelected || (slot.bookable && this.checkAvailability(slot))

      return canRenderSlot
        ? <td
            key={i}
            id={cellId}
            className={`theme-calendar-cell-all theme-calendar-cell-all--${theme}${isSelected ? ' theme-calendar--selected' : ''}`}
            onClick={ data => this.handleClick(data)}>
            <span className="theme-calendar-slot-time">{`${slotHour}:${slotMinutes}`}</span>
            {discountAmount > 0 && <span className="theme-calendar-discount-badge">-{formatDiscountAmount(discountAmount)}€</span>}
          </td>
        : <td
            key={i}
            id={cellId}
            className="theme-calendar-unavailable"></td>
    })
  }

  render() {
    const {intl:{formatMessage}} = this.props
    const allowedThemes = Array.isArray(this.props.allowedThemes)
      ? this.props.allowedThemes
      : ['la', 'vbn', 'abattoir', 'yakuza', 'tombeau']
    const charonneRooms = [
      { theme: 'la', roomId: this.getRoomIdForTheme('la', 27), label: formatMessage(messages.la) },
      { theme: 'vbn', roomId: this.getRoomIdForTheme('vbn', 28), label: formatMessage(messages.VBN) },
    ].filter(room => allowedThemes.indexOf(room.theme) > -1)
    const voltaireRooms = [
      { theme: 'abattoir', roomId: this.getRoomIdForTheme('abattoir', 29), label: formatMessage(messages.slaughterhouse) },
      { theme: 'yakuza', roomId: this.getRoomIdForTheme('yakuza', 31), label: formatMessage(messages.yakuza) },
      { theme: 'tombeau', roomId: this.getRoomIdForTheme('tombeau', 32), label: formatMessage(messages.tombeau) },
    ].filter(room => allowedThemes.indexOf(room.theme) > -1)
    const calendarRooms = charonneRooms.concat(voltaireRooms)
    const hasAvailableSlot = calendarRooms.some(room =>
      this.getRoomSlots(room.roomId).some(slot => slot.bookable && this.checkAvailability(slot))
    )
    const isFullyBooked = !hasAvailableSlot && this.props.selectedSlots.length === 0
    const selectedDate = this.props.date.clone().locale(this.props.lang === 'fr' ? 'fr' : 'en')
    const isToday = selectedDate.isSame(moment(), 'day')
    const formattedDate = selectedDate.format('dddd D MMMM YYYY')
    let maxSlots = calendarRooms.reduce((length, room) => {
      const roomSlots = this.getRoomSlots(room.roomId)
      return roomSlots.length > length ? roomSlots.length : length
    }, 0)
    maxSlots++; // Header
    maxSlots++; // Header

    return (
      <div className={`theme-calendar-full-day${isFullyBooked ? ' theme-calendar-full-day--active' : ''}`}>
      <table className="theme-calendar theme-calendar--all">
        <thead className="theme-calendar-header theme-calendar-header--all">
          <tr>
            <th colSpan={maxSlots}>
              <span>One Hour Charonne</span> / 24 rue Emile Lepeu 75011 Paris
            </th>
          </tr>
        </thead>
        <tbody className="theme-calendar-body theme-calendar-body--all">
          {charonneRooms.map(room => (
            <tr key={room.theme} className={`theme-calendar-row--${room.theme}`}>
              <td className={`theme-calendar-row-pre theme-calendar-row-pre--${room.theme}`}></td>
              <td className="theme-calendar-theme-name">
                <div style={{ display: "flex", alignItems: "center", textAlign: "left"}}>
                  {room.label}
                </div>
              </td>
              {this.renderRoomCells(room.theme, room.roomId)}
            </tr>
          ))}
        </tbody>
        <thead className="theme-calendar-header theme-calendar-header--all">
          <tr>
            <th colSpan={maxSlots}>
              <span>One Hour Voltaire</span> / 23 rue Servan 75011 Paris
            </th>
          </tr>
        </thead>
        <tbody className="theme-calendar-body theme-calendar-body--all">
          {voltaireRooms.map(room => (
            <tr key={room.theme} className={`theme-calendar-row--${room.theme}`}>
              <td className={`theme-calendar-row-pre theme-calendar-row-pre--${room.theme}`}></td>
              <td className="theme-calendar-theme-name">
                <div style={{ display: "flex", alignItems: "center", textAlign: "left"}}>
                  {room.label}
                </div>
              </td>
              {this.renderRoomCells(room.theme, room.roomId)}
            </tr>
          ))}
        </tbody>
      </table>
      {isFullyBooked && (
        <div className="theme-calendar-full-day__overlay" role="status">
          <div className="theme-calendar-full-day__content">
            <FontAwesomeIcon className="theme-calendar-full-day__icon" icon={faCalendarTimes} />
            <h3>
              {this.props.lang === 'fr'
                ? (isToday ? "Complet pour aujourd'hui !" : 'Complet pour ce jour !')
                : (isToday ? 'Fully booked today!' : 'Fully booked on this day!')}
            </h3>
            <p>
              {this.props.lang === 'fr'
                ? `Toutes nos salles sont réservées pour ce ${formattedDate}.`
                : `All our rooms are booked for ${formattedDate}.`}
            </p>
            <button type="button" onClick={this.props.handleNextDay}>
              <span>{this.props.lang === 'fr' ? 'Voir le jour suivant' : 'See the next day'}</span>
              <span aria-hidden="true">→</span>
            </button>
          </div>
        </div>
      )}
      </div>
    )
  }
}

const messages = defineMessages({
  la: {
    id: 'themes.la',
    defaultMessage: 'lost asylum'
  },
  VBN: {
    id: 'themes.VBN',
    defaultMessage: 'Very Bad Night'
  },
  slaughterhouse: {
    id: 'themes.slaughterhouse',
    defaultMessage: "L'abattoir"
  },
  yakuza: {
    id: 'themes.yakuza',
    defaultMessage: "Yakuza"
  },
  tombeau: {
    id: 'themes.tombeau',
    defaultMessage: "Expédition Maudite"
  },
})

const emptyCalendar = [
  {
  already_booked_for: "0",
  time_begin: "10:00:00",
  time_end: "12:00:00",
  id_room_calendar: "67",
  normal_price_type: "c",
  other_price_type: null,
  necessary_resource_quantity: "1",
  company_id: "30",
  global_price: "c",
  min_nb_resource_available: "-1",
  bookable: false,
  quantity_resource_booked: "0"
  },
  {
  already_booked_for: "0",
  time_begin: "12:00:00",
  time_end: "14:00:00",
  id_room_calendar: "68",
  normal_price_type: "c",
  other_price_type: null,
  necessary_resource_quantity: "1",
  company_id: "30",
  global_price: "c",
  min_nb_resource_available: "-1",
  bookable: false,
  quantity_resource_booked: "0"
  },
  {
  already_booked_for: "0",
  time_begin: "14:00:00",
  time_end: "16:00:00",
  id_room_calendar: "69",
  normal_price_type: "c",
  other_price_type: null,
  necessary_resource_quantity: "1",
  company_id: "30",
  global_price: "c",
  min_nb_resource_available: "-1",
  bookable: false,
  quantity_resource_booked: "0"
  },
  {
  already_booked_for: "0",
  time_begin: "16:00:00",
  time_end: "18:00:00",
  id_room_calendar: "70",
  normal_price_type: "c",
  other_price_type: null,
  necessary_resource_quantity: "1",
  company_id: "30",
  global_price: "c",
  min_nb_resource_available: "-1",
  bookable: false,
  quantity_resource_booked: "0"
  },
  {
  already_booked_for: "0",
  time_begin: "18:00:00",
  time_end: "20:00:00",
  id_room_calendar: "71",
  normal_price_type: "p",
  other_price_type: null,
  necessary_resource_quantity: "1",
  company_id: "30",
  global_price: "p",
  min_nb_resource_available: "-1",
  bookable: false,
  quantity_resource_booked: "0"
  },
  {
  already_booked_for: "0",
  time_begin: "20:00:00",
  time_end: "22:00:00",
  id_room_calendar: "72",
  normal_price_type: "p",
  other_price_type: null,
  necessary_resource_quantity: "1",
  company_id: "30",
  global_price: "p",
  min_nb_resource_available: "-1",
  bookable: false,
  quantity_resource_booked: "0"
  },
  {
  already_booked_for: "0",
  time_begin: "22:00:00",
  time_end: "23:59:00",
  id_room_calendar: "73",
  normal_price_type: "p",
  other_price_type: null,
  necessary_resource_quantity: "1",
  company_id: "30",
  global_price: "p",
  min_nb_resource_available: "-1",
  bookable: false,
  quantity_resource_booked: "0"
  }
]

export default injectIntl(AllThemesCalendar)



// WEBPACK FOOTER //
// ./src/components/AllThemesCalendar.js